<template>
  <div>
    <!-- 날짜 -->
    <div class="absolute top-0 flex items-center gap-4" :class="[!isPrint && 'py-6']" style="left: calc(190px + 3rem)">
      <div v-if="isPrint" class="flex items-center justify-center gap-3">
        <p class="print-input">{{ form.headerDate | moment("YYYY") }}</p>
        년
        <p class="print-input">{{ form.headerDate | moment("M") }}</p>
        월
      </div>
      <month-picker v-else class="inline-block" v-model="form.headerDate" :readonly="board.readonly">
        <template v-slot="{ inputValue, year, month, onClick }">
          <div class="flex items-center justify-center gap-3 cursor-pointer" @click="onClick">
            <ml-input style="width: 100px" class="header-month" :class="[board.readonly && 'readonly']" :value="year" readonly />
            <p>년</p>
            <ml-input style="width: 100px" class="header-month" :class="[board.readonly && 'readonly']" :value="month" readonly />
            <p>월</p>
          </div>
        </template>
      </month-picker>
    </div>

    <p style="font-size: 16px; line-height: 17px" class="mb-5">※ [<b>위험성평가</b>(유해·위험요인 파악) → <b>위험성평가회의</b>(위험성평가의 공유) → <b>교육·TBM 전파</b>(위험성 결정, 감소대책 수립) → <b>이행확인</b>(감소대책 실행)]</p>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" :propTypesTitle="{ com_name: '부서(업체)명' }" />

    <!-- 위험성평가 정보 -->
    <div>
      <h5 class="mt-6"><i class="dot"></i> 위험성평가 정보</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_2" />
        </div>
        <div>
          <div>관리기간</div>
          <p v-if="isPrint" class="print-input">{{ `${form.inputA_3}~${form.inputA_4}` }}</p>
          <div v-else class="time">
            <date-selector v-model="form.inputA_3" :readonly="board.readonly" />
            ~
            <date-selector v-model="form.inputA_4" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>예정공정표 첨부</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputA_5.fileName }}
          </p>
          <file-uploader v-else :readonly="board.readonly" v-model="form.inputA_5" class="w-full flex-1" />
        </div>
        <div class="writeGridLineItem">
          <div>예정공정 현황</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputA_6 }}</p>
          <ml-textarea
            v-else
            :readonly="board.readonly"
            v-model="form.inputA_6"
            height="90px"
            placeholder="지하2층, 지상 15층 주상복합 신축현장, 작성일 현재 공정률 약 40%이며, 5월 한 달간 지상 8층~10층 구조물 공사, 지하1층 ∼ 지상 3층 내외부 마감공사가 진행 예정임"
          />
        </div>
      </div>
    </div>

    <!-- 위험성평가 -->
    <RiskTable v-model="form.riskList" class="mb-6" />

    <!-- ➆ 위험성 결정, 감소대책 수립 및 실행계획 확인 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="➆ 위험성 결정, 감소대책 수립 및 실행계획 확인"
      :controls="false"
      :multiple="false"
      :tableData="[
        { id: 'target', title: '소속명', type: 'text', placeholder: '내용' },
        { id: 'position', title: '직급', type: 'select', selectData: workRank, placeholder: '선택' },
        { id: 'type', title: '직책', type: 'text', readonly: true },
        { id: 'name', title: '이름', type: 'text', placeholder: '내용' },
        { id: 'sign', title: '서명', type: 'sign' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.managerList"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import TableCustom from "@/components/TableCustom.vue";
import RiskTable from "./RiskTable.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    RiskTable,
    DateSelector,
    FileUploader,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      headerDate: { required },
      stdInfo: {
        field_name: { required },
      },
      inputA_1: { required },
      inputA_2: { required },
      inputA_3: { required },
      inputA_4: { required },
      inputA_5: { required },
      inputA_6: { required },

      riskList: { required, minLength: minLength(1) },
    },
  },
  computed: {
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        value.riskDisaster = value.riskList.map((item) => item.input4).join(", ");
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        headerDate: "",
        stdInfo: {},
        fileList: [],
        riskDisaster: "",
        riskList: [],
        managerList: [
          { id: 1, type: "담당자(공사담당자)" },
          { id: 2, type: "검토자(안전관리자)" },
          { id: 3, type: "근로자 대표 /(작업반장 등)" },
          { id: 4, type: "승인자(현장소장)" },
        ],

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: {},
        inputA_6: "",
      },
      workRank: ["감독관", "관리책임자", "현장소장", "부장", "차장", "과장", "대리", "계장", "주임", "협력업체"],
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.headerDate.required) return "날짜는 반드시 선택해야 합니다";
        if (!this.$v.form.stdInfo.field_name.required) return "현장명을 반드시 입력해야 합니다";
        if (!this.$v.form.inputA_1.required) return "작업내용을 반드시 입력해야 합니다";
        if (!this.$v.form.inputA_2.required) return "평가일을 반드시 입력해야 합니다";
        if (!this.$v.form.inputA_3.required) return "관리기간을 반드시 입력해야 합니다";
        if (!this.$v.form.inputA_4.required) return "관리기간을 반드시 입력해야 합니다";
        if (!this.$v.form.inputA_5.required) return "예정공정표를 반드시 첨부해야 합니다";
        if (!this.$v.form.inputA_6.required) return "예정공정 현황을 반드시 입력해야 합니다";
        if (!this.$v.form.riskList.required) return "위험성평가 항목을 한개이상 입력해야 합니다";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header-month::v-deep {
  input {
    background: white;
  }
  &.readonly input {
    background: #fafafa !important;
  }
}
</style>
